import tasks from './mentoring/tasks';
import activities from './mentoring/activities';
import files from './mentoring/files';
import news from './mentoring/news';
import surveys from './mentoring/surveys';
import { get, post } from '../tools/http';

const client = {
    async getUserGroups(userId) {
        return get('profile', `user/${userId}/groups`);
    },
    async getGroupPairs(groupId) {
        return get('profile', `group/${groupId}/pairs`);
    },
    async getPairProfile(userId) {
        return post('profile', `users/filter`, {
            'fields': ['userId', 'avatar', 'name', 'surname', 'patronymic'],
            'filters': [
                {
                    'name': 'userId',
                    'value': userId,
                },
            ],
        }, true);
    },
};

const
    role_student = 'student',
    role_mentor = 'mentor';

export default {
    namespaced: true,

    state: {
        groupId: null,
        role: null,
        pair: null,
        mentoring: null,
    },
    mutations: {
        setGroup: (state, item) => state.groupId = item.id,
        setRole: (state, value) => state.role = value,
        setPair: (state, item) => state.pair = item,
        setMentoring(state, mentoring) {
            state.mentoring = mentoring;
        },
    },
    actions: {
        async loadGroup(ctx) {
            let groups = (await client.getUserGroups(ctx.rootState.auth.user.id)).groups;
            if (!Array.isArray(groups) || groups.length === 0) {
                return;
            }
            ctx.commit('setGroup', groups[0]);
            let pairs = (await client.getGroupPairs(ctx.state.groupId)).pairs;
            let userId = ctx.rootState.auth.user.id;
            let pairId;
            pairs.forEach(pair => {
                if (pair['studentId'] === userId) {
                    ctx.commit('setRole', role_student);
                    pairId = pair['leaderId'];
                }
                if (pair['leaderId'] === userId) {
                    ctx.commit('setRole', role_mentor);
                    pairId = pair['studentId'];
                }
            });
            let profiles = (await client.getPairProfile(pairId)).users;
            if (profiles.length === 0) {
                return;
            }
            ctx.commit('setPair', profiles[0]);
        },
        async getMentoring({ commit }) {
            const answer = await get(
                'cms',
                'entity/select/page?name=mentoring'
            );
            if (answer && answer.list) {
                const mentoring = answer.list[0] || null;
                commit('setMentoring', mentoring);
            }
        },
    },
    getters: {
        mentoringField: state => key =>
            state.mentoring && state.mentoring.data
                ? state.mentoring.data[key]
                : '',
        getPair: state => state.pair,
        isStudent: state => state.role === role_student,
        isMentor: state => state.role === role_mentor,
        isMentoringParticipant: state => state.role !== null,
    },
    modules: {
        tasks,
        activities,
        files,
        news,
        surveys,
    },
};
